function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 5.5a1 1 0 000 2h21a1 1 0 100-2H9zM9 24.5a1 1 0 100 2h21a1 1 0 100-2H9zM4 25.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM4 16a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM9 15a1 1 0 100 2h21a1 1 0 100-2H9z",
  fill: "currentColor"
})));